import * as React from 'react';
import classNames from 'classnames';

interface Props {
  label: string;
  name: string;
  choices: { [value: string]: string; };
  selected: string;
  onChange: (selected: string) => void;
  isChoiceDisabled?: (choice: string) => boolean;
}

export default ({ label, name, choices, selected, onChange, isChoiceDisabled }: Props) => (
  <div className="row">
    <label className="col-sm-3 control-label">{label}</label>
    <div className="col-sm-9">
      {Object.keys(choices).map(choice => (
        <div key={choice} className={classNames(
          'form-check checkbox-inline',
          { disabled: isChoiceDisabled && isChoiceDisabled(choice) },
        )}>
          <label className="form-check-label form-check-radio radio-inline">
            <input
              className="form-check-input"
              type="radio"
              name={name}
              disabled={isChoiceDisabled && isChoiceDisabled(choice)}
              checked={selected === choice}
              onClick={() => onChange(choice)}
            />
            <span className="form-check-sign" />
            {choices[choice]}
          </label>
        </div>
      ))}
    </div>
  </div>
);
